import React, { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "./api.js";
import Shell from "./Shell";
import { tilesForRole } from "./navConfig";

export default function RoleDashboard() {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        // dev/test override: ?role=... or localStorage.roleOverride
        const override = search.get("role") || localStorage.getItem("roleOverride");
        if (override) {
          if (alive) setRole(override);
          return;
        }
        // real role from API (axios interceptors attach auth)
        const { data } = await api.get("/api/user/role/");
        if (alive) setRole(data.role);
      } catch {
        if (alive) setRole("staff"); // safe fallback
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [search]);

  const tiles = useMemo(() => tilesForRole(role), [role]);

  if (loading || !role) return <Shell rightMenu loading />;

  return (
    <Shell rightMenu menuItems={tiles}>
      <div className="tile-grid">
        {tiles.map((t) => (
          <Link
            to={t.to}
            key={t.key}
            className="tile"
            // make the Blue Box pop
            style={t.key === "bluebox" ? {
              background: "#2563eb",
              color: "#fff",
              borderColor: "#2563eb",
              fontWeight: 600,
            } : undefined}
          >
            {t.title}
          </Link>
        ))}
      </div>
    </Shell>
  );
}